import { Controller, useFormContext } from 'react-hook-form';

import {
  getDefaultPeriodMaxDate,
  getDefaultPeriodMinDate,
} from '~domains/commerce/features/period-filter';

import {
  DateRangePicker,
  getDefaultPeriodPresets,
} from '~shared/ui/date-range-picker';

import type { DashboardFiltersValue } from '../model/dashboard-filters';

const PERIOD_PRESETS = getDefaultPeriodPresets();

type Props = {
  onChange?: () => void;
};

export function DashboardPeriodFilter({ onChange }: Props) {
  const { control } = useFormContext<DashboardFiltersValue>();
  const minDate = getDefaultPeriodMinDate();
  const maxDate = getDefaultPeriodMaxDate();

  return (
    <Controller
      control={control}
      name="period"
      render={({ field, ...controllerProps }) => (
        <DateRangePicker
          {...controllerProps}
          field={{
            ...field,
            onChange: (period: DashboardFiltersValue['period']) => {
              field.onChange(period);

              const isComplete = Boolean(period.startDate && period.endDate);
              const isCleared = !period.startDate && !period.endDate;

              if (isComplete || isCleared) {
                onChange?.();
              }
            },
          }}
          align="end"
          minDate={minDate}
          maxDate={maxDate}
          presets={PERIOD_PRESETS}
        />
      )}
    />
  );
}
